import { ApiWrapperState } from './types';

export const defaultApiWrapperState: ApiWrapperState = {
	commonLocalErrorHandler: undefined,
	commonGlobalErrorHandler: undefined,
};
